import Simplemodal from '../../plugins/simplemodal.js';

const fullScreenMenu = new Simplemodal({
  trigger : "data-fullScreenMenu-trigger",
  clickOutSideClose : true,
  onOpen: openAction,
  onClose: closeAction,
})

function openAction() {
  document.querySelector("body").classList.add("is-menu-open");
}
function closeAction() {
  document.querySelector("body").classList.remove("is-menu-open");
}